<template>
<div class="chapter">
<div class="inner_page">
<p class="copy">Publisher: Amy Marson</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Art Director / Cover Designer: Kristy Zacharias</p>
<p class="copy">Editors: S. Michele Fry and Joanna Burgarino</p>
<p class="copy">Technical Editors: Alison M. Schmidt and Nan Powell</p>
<p class="copy">Book Designer: Katie McIntosh</p>
<p class="copy">Production Coordinator: Freesia Pearson Blizard</p>
<p class="copy">Production Editor: Katie Van Amburg</p>
<p class="copy">Illustrators: Amanda Murphy and Jenny Davis</p>
<p class="copy">Photo Assistant: Mary Peyton Peppo</p>
<p class="copy">Style photography by Nissa Brehmer and instructional photography by Diane Pedersen, unless otherwise noted</p>
<p class="copy">Published by Stash Books, an imprint of C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?05d14a23